import { combineReducers } from 'redux';
import drawerReducer from './drawer';

const reducer = combineReducers({
  drawer: drawerReducer,
});

export default reducer;
